export const getInput = (input_name, states, inputs_) => {
 //console.log("getinput", input_name, states, inputs_);
  return inputs_[input_name];
}
